<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar d-flex justify-space-between">
    <div>
      <div class="mobile-elements d-flex d-md-none">
        <!--begin::Logo-->
        <a href="/">
          <img alt="Logo" :src="headerLogo" />
        </a>
        <!--end::Logo-->
        <!--begin::Toolbar-->

        <!--end::Toolbar-->
      </div>
    </div>
    <!--begin: Language bar -->
    <!-- <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
      >
        <template v-slot:button-content>
          <img
            class="h-20px w-20px rounded-sm"
            :src="languageFlag || getLanguageFlag"
            alt=""
          />
        </template>
        <b-dropdown-text tag="div" class="min-w-md-175px">
          <KTDropdownLanguage
            v-on:language-changed="onLanguageChanged"
          ></KTDropdownLanguage>
        </b-dropdown-text>
      </b-dropdown>
    </div> -->
    <!--end: Language bar -->
    <div class="d-flex">
      <div class="d-flex align-items-center d-flex d-md-none">
        <!--begin::Aside Mobile Toggle-->
        <button
          v-if="asideEnabled"
          class="btn p-0 burger-icon burger-icon-left"
          id="kt_aside_mobile_toggle"
        >
          <span></span>
        </button>
        <!--end::Aside Mobile Toggle-->
      </div>
      <!--begin: User Bar -->
      <KTQuickUser></KTQuickUser>
      <!--end: User Bar -->
    </div>
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
  .mobile-elements {
    img {
      width: 100px;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
// import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages,
      searchQuery: ""
    };
  },
  components: {
    // KTDropdownLanguage,
    KTQuickUser
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get header logo
     * @returns {string}
     */
    headerLogo() {
      return process.env.BASE_URL + this.layoutConfig("self.logo.dark");
    },
    /**
     * Get classes for mobile header
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header_mobile");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    getLanguageFlag() {
      return this.onLanguageChanged();
    }
  }
};
</script>
